import React from "react";
import styled from "styled-components";

import * as Animation from "~/Animation";
import * as Color from "~/Color";
import * as Icon from "~/Icon";
import * as Layout from "~/Layout";
import * as Typography from "~/Typography";

export type Props = React.HTML<"a"> & {
  readonly disabled?: boolean;
  readonly back?: boolean;
  readonly forward?: boolean;
};

export const Component: Component<Props> = ({
  ref,
  back,
  forward,
  children,
  ...props
}) => (
  <Anchor.Component {...props}>
    {back && (
      <Layout.Inline.Component right>
        <Icon.ArrowLeft faded />
      </Layout.Inline.Component>
    )}
    {children}
    {forward && (
      <Layout.Inline.Component left>
        <Icon.ArrowRight faded />
      </Layout.Inline.Component>
    )}
  </Anchor.Component>
);

const LinkComponent = Component;

export namespace ViewDetails {
  export const Component = ({
    children,
    ...props
  }: React.PropsWithChildren<Props>) => (
    <LinkComponent forward {...props}>
      {children ?? <>View details</>}
    </LinkComponent>
  );
}

namespace Anchor {
  export const Component = styled.a<Props>`
    display: inline-block;
    position: relative;

    color: ${() => Color.azure()};
    text-decoration: none;
    cursor: pointer;

    ${() => Animation.Transition.styles(Animation.fast())}

    /* Ant override. */
    &[disabled], &:disabled {
      ${({ disabled }) => (disabled ? "cursor: not-allowed;" : "")};
      color: ${() => Typography.Muted.color()} !important;

      /* Ant override. */
      pointer-events: auto;

      &:before {
        display: none;
      }

      &:hover {
        transform: unset;
      }

      &:active {
        transform: unset;
      }
    }

    &:hover {
      color: ${() => Color.azure()};
      transform: translateY(-1px);
      &:before {
        visibility: visible;
        transform: scaleX(1);
      }
    }

    &:active {
      transform: translateY(0);
    }

    &:before {
      content: "";
      visibility: hidden;

      position: absolute;
      left: 0;
      bottom: 0em;

      width: 100%;
      height: 1px;
      transform: scaleX(0);

      opacity: 0.5;
      background: ${() => Color.azure()};

      ${() => Animation.Transition.styles(Animation.fast())}
    }
  `;
}
